import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import meKeys from '../me/keyFactory';

const GetTimelogTypes = graphql(`
  query GetTimelogTypes {
    me {
      user {
        account {
          timelogPreferences {
            types {
              id
              name
              description
              category
              isAvailableForGeneralTimelogs
            }
          }
        }
      }
    }
  }
`);

export const useGetTimelogTypes = () => {
  const { data, ...rest } = useQuery({
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    queryKey: meKeys.accountTimelogTypes(),
    queryFn: () => {
      return gqlClient.request(GetTimelogTypes);
    },
  });

  return {
    data,
    timelogTypes: data?.me.user.account.timelogPreferences?.types ?? [],
    ...rest,
  };
};
